import { makeStyles } from 'tss-react/mui'
import {Instance as TinyColor} from 'tinycolor2'


const useStyles = makeStyles<{color: TinyColor}>()((theme, params) => ({
    container: {
        width: '202px',
        padding: theme.spacing(1),
    },
    divider: {
        margin: theme.spacing(0.75, 0)
    },
    thumbnail: {
        height: '20px',
        width: '20px',
        background: params.color.toRgbString(),
        borderRadius: '2px',
        overflow: 'hidden'
    },
    colorDisplay: {
        fontSize: '0.75rem',
        border: '1px solid',
        borderRadius: '2px',
        padding: theme.spacing(0, 0.5),
        opacity: 0.8
    }
}))

export default useStyles